import { loadErrorMessage } from '../utils/loadState'
import './LoadError.css'

/**
 * What a list screen shows when its request failed (queue item 201): the failure, in
 * words, and a Retry -- never an empty list, never a zero. `inline` is the compact form
 * for a picker or a dropdown inside a larger page.
 */
export default function LoadError({ what, error, onRetry, inline = false }) {
  return (
    <div className={`load-error${inline ? ' load-error--inline' : ''}`} role="alert">
      <span className="load-error-text">
        <strong>Couldn&apos;t load {what}.</strong> {loadErrorMessage(error)}
      </span>
      {onRetry && (
        <button type="button" className="load-error-retry" onClick={onRetry}>Retry</button>
      )}
    </div>
  )
}
